import styled from 'styled-components';
import React from 'react';
import media from 'client/styles/media';
import { Link } from 'react-router-dom';

import PaddingContainer from './PaddingContainer';

const SupportersSection = styled(PaddingContainer)`
  position: relative;
  width: 100%;
  padding-bottom: 80px;
  img {
    display: block;
    max-width: 100%;
  }
  .supporters-main {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
    background: url(https://static.introwise.com/images/elements/main/orange_block.svg) no-repeat;
    background-size: 100% 100%;
    padding: 30px 30px 10px;
    margin: 0 -30px;
    ${({ theme }) => theme.typography.h4};
  }
  .supporters-other {
    background: url(https://static.introwise.com/images/elements/main/orange_frame.svg) no-repeat;
    background-size: 100% 100%;
    padding: 40px 35px 20px;
    margin: -20px -35px 0;
    img {
      margin-top: 10px;
    }
  }
  ${media.sm} {
    .supporters-other {
      padding: 50px 50px 20px;
      margin: -20px -30px 0;
    }
  }

  ${media.md} {
    display: grid;
    grid-template-columns: repeat(12, 1fr);
    .supporters-main {
      grid-column: 1 / span 7;
      padding: 50px 40px 30px 50px;
      margin: 0 -10px 0 0;
    }
    .supporters-other {
      grid-column: 8 / span 5;
      margin: 0;
      padding: 30px 30px 15px;
    }
  }

  ${media.lg} {
    .supporters-main {
      grid-column: 2 / span 6;
    }
    .supporters-other {
      grid-column: 8 / span 4;
    }
  }
`;

const SupportersLink = styled(Link)`
  font-weight: bold;
  color: #e54500;
  :hover,
  :focus {
    color: #e54500;
    opacity: ${({ theme }) => theme.button.opacity.hover};
    text-decoration: none;
  }
`;

const Supporters = () => (
  <SupportersSection>
    <div className="supporters-main">
      <img src="https://static.introwise.com/images/elements/main/supporters_main.png" alt="" />
      <p>
        Powering events and communities! <SupportersLink to="/communities-intro">Want to start yours?</SupportersLink>
      </p>
    </div>
    <div className="supporters-other">
      Made with the help of <img src="https://static.introwise.com/images/elements/main/supporters_others.jpg" alt="" />
    </div>
  </SupportersSection>
);

export default Supporters;
